const VideoStage = ({
  children,
  label,
  className,
  hideLabel = false,
}: {
  children: React.ReactNode;
  label: React.ReactNode;
  className?: string;
  hideLabel?: boolean;
}) => (
  <div className={className}>
    {hideLabel ? null : (
      <div className="mb-2 text-xs font-medium uppercase tracking-[0.18em] text-muted-foreground">
        {label}
      </div>
    )}
    {children}
  </div>
);

export default VideoStage;
